import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesWithTracking from "./RoutesWithTracking";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./ScrollToTop";

import "./App.css";

function App() {
  window.onerror = function(message, source, lineno, colno, error) {
    fetch("https://buytaxi.co.il/api/logErrors", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        message, 
        source, 
        lineno, 
        colno, 
        error: error?.stack || error 
      }),
    });
  };

  return (
<Router>
  <ScrollToTop />
  <div className="main-container">
    <Header />
    <div className="content">
      <RoutesWithTracking />
    </div>
    <Footer />
  </div>
</Router>

  );
}

export default App;
